/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../.kubb/ToZod.ts";
import type { CourseDocumentsListItemViewModelPaginatedResponse } from "../types/CourseDocumentsListItemViewModelPaginatedResponse.ts";
import { courseDocumentsListItemViewModelSchema } from "./courseDocumentsListItemViewModelSchema.ts";

export const courseDocumentsListItemViewModelPaginatedResponseSchema = z.object(
  {
    data: z
      .array(z.lazy(() => courseDocumentsListItemViewModelSchema))
      .nullish(),
    currentPage: z.optional(z.number().int()),
    totalPages: z.optional(z.number().int()),
    totalCount: z.optional(z.number().int()),
  },
) as unknown as ToZod<CourseDocumentsListItemViewModelPaginatedResponse>;
